<script lang="ts" setup>
// eslint-disable-next-line import/no-unresolved
import logoSpinner1 from '@images/spinner/logo-spinner-01.png'
// eslint-disable-next-line import/no-unresolved
import logoSpinner2 from '@images/spinner/logo-spinner-02.png'
// eslint-disable-next-line import/no-unresolved
import logoSpinner3 from '@images/spinner/logo-spinner-03.png'

const props = defineProps({
  loadingText: {
    type: String,
    default: null,
  },
  size: {
    type: Number,
    default: 110,
  },
})

const spinnerStyles = computed(() => {
  let halfSize = Math.ceil(props.size / 2)

  return `margin: -${halfSize}px 0 0 -${halfSize}px; transform-origin: ${halfSize}px ${halfSize}px ${halfSize}px;`
})
</script>

<template>
  <div
    class="spinner mx-auto"
    :style="`height: ${size*2}px`"
  >
    <h3
      v-if="loadingText"
      class="loading-text"
    >
      {{ loadingText }}
    </h3>
    <img
      class="spinner__img spinner__img--img01"
      :src="logoSpinner1"
      :style="spinnerStyles"
      :width="size"
      :height="size"
    >
    <img
      class="spinner__img spinner__img--img02"
      :src="logoSpinner2"
      :style="spinnerStyles"
      :width="size"
      :height="size"
    >
    <img
      class="spinner__img spinner__img--img03"
      :src="logoSpinner3"
      :style="spinnerStyles"
      :width="size"
      :height="size"
    >
  </div>
</template>

<style lang="scss">
.spinner {
  position: relative;

  &__img {
    position: absolute;
    top: 50%;
    left: 50%;

    &--img01 {
      animation: spin 2s linear infinite;
    }

    &--img02 {
      animation: spin-reverse 3s linear infinite;
    }

    &--img03 {
      animation: spin 4s linear infinite;
    }
  }
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spin-reverse {
  100% {
    transform: rotate(-360deg);
  }
}
</style>
